import { useState, useEffect, useCallback } from "react";
import {
  getAdminStats, getStudents, getBatches, createBatch, deleteBatch,
  getAllBookings, updateBookingStatus, upsertMeeting, sendMeetEmail,
  createSlots, exportStudentsCSV, assignStudentBatch, getAllContacts
} from "../services/api";
import "./AdminDashboard.css";
import AdminMessages from "./AdminMessages";

// ─── Icons ────────────────────────────────────────────────────────────────────
const Icon = {
  grid: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>,
  users: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
  video: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7" /><rect x="1" y="5" width="15" height="14" rx="2" ry="2" /></svg>,
  calendar: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>,
  check: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>,
  layers: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /></svg>,
  mail: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>,
  clock: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
  download: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>,
  trash: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
  plus: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>,
  send: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" /></svg>,
  link: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>,
  menu: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="21" y2="18" /></svg>,
  externalLink: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>,
};

const STATUS_COLORS = { confirmed: "badge-blue", cancelled: "badge-red", completed: "badge-green" };

const TABS = [
  { id: "overview", label: "Overview", icon: Icon.grid },
  { id: "students", label: "Students & Batches", icon: Icon.users },
  { id: "sessions", label: "Sessions", icon: Icon.video },
  { id: "bookings", label: "Bookings", icon: Icon.calendar },
  { id: "contacts", label: "Contacts", icon: Icon.mail },
  { id: "messages", label: "Messages", icon: Icon.send },
];

// ─── Sub-tab pill nav ─────────────────────────────────────────────────────────
function PillNav({ tabs, active, onChange }) {
  return (
    <div className="pill-nav">
      {tabs.map(t => (
        <button
          key={t.id}
          className={`pill-btn ${active === t.id ? "active" : ""}`}
          onClick={() => onChange(t.id)}
        >
          {t.icon && <span className="pill-icon">{t.icon}</span>}
          {t.label}
        </button>
      ))}
    </div>
  );
}

// ─── StatCard ─────────────────────────────────────────────────────────────────
function StatCard({ label, value, icon, accent }) {
  return (
    <div className="stat-card" style={{ "--accent": accent }}>
      <div className="stat-card-icon">{icon}</div>
      <div className="stat-card-value">{value ?? "—"}</div>
      <div className="stat-card-label">{label}</div>
    </div>
  );
}

// ─── Alert ───────────────────────────────────────────────────────────────────
function Alert({ text, type }) {
  if (!text) return null;
  return <div className={`alert alert-${type || "success"}`}>{text}</div>;
}

// ═══════════════════════════════════════════════════════════════════════════════
export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("overview");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [stats, setStats] = useState(null);

  // ── Students & Batches state ──
  const [students, setStudents] = useState([]);
  const [studentsLoading, setStudentsLoading] = useState(false);
  const [studentFilter, setStudentFilter] = useState("all");
  const [studentSubTab, setStudentSubTab] = useState("list");
  const [batches, setBatches] = useState([]);
  const [newBatchName, setNewBatchName] = useState("");
  const [newBatchDesc, setNewBatchDesc] = useState("");
  const [batchMsg, setBatchMsg] = useState({ text: "", type: "" });
  const [contacts, setContacts] = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  // ── Sessions state ──
  const [sessionSubTab, setSessionSubTab] = useState("meeting");
  const [meetForm, setMeetForm] = useState({
    meet_link: "", session_time: "7:00 PM IST", title: "Daily Live Class", is_active: true, date: "",
  });
  const [meetMsg, setMeetMsg] = useState({ text: "", type: "" });

  const [emailForm, setEmailForm] = useState({
    meet_link: "", session_time: "7:00 PM IST",
    session_title: "Daily Live Session", batch_id: "all", custom_message: "",
  });
  const [emailMsg, setEmailMsg] = useState({ text: "", type: "" });
  const [emailSending, setEmailSending] = useState(false);

  const [slotDate, setSlotDate] = useState("");
  const [selectedTimes, setSelectedTimes] = useState([]);
  const [customTime, setCustomTime] = useState("");
  const [slotsMsg, setSlotsMsg] = useState({ text: "", type: "" });

  // ── Bookings state ──
  const [bookings, setBookings] = useState([]);
  const [bookingsLoading, setBookingsLoading] = useState(false);
  const [bookingFilter, setBookingFilter] = useState("all");

  // ── Data loaders ──
  const loadStats = useCallback(async () => {
    try { 
      const r = await getAdminStats(); 
      console.log(r.data);
      setStats(r.data); } 
    catch (error) {
      console.error("Error loading stats:", error);
    }
  }, []);

  const loadStudents = useCallback(async (batchId = "all") => {
    setStudentsLoading(true);
    try {
      const r = await getStudents(batchId === "all" ? null : batchId);
      setStudents(r.data.students);
    } catch { setStudents([]); }
    setStudentsLoading(false);
  }, []);

  const loadBatches = useCallback(async () => {
    try { const r = await getBatches(); setBatches(r.data); } catch { }
  }, []);

  const loadBookings = useCallback(async () => {
    setBookingsLoading(true);
    try { const r = await getAllBookings(); setBookings(r.data.bookings); } catch { setBookings([]); }
    setBookingsLoading(false);
  }, []);

  const loadContacts = useCallback(async () => {
    setContactsLoading(true);
    try {
      const r = await getAllContacts();
      setContacts(r.data.contacts);
    } catch {
      setContacts([]);
    }
    setContactsLoading(false);
  }, []);
  useEffect(() => {
    const token = localStorage.getItem("admin_token");

    if (!token) {
      window.location.href = "/admin-login";
    }
  }, []);
  useEffect(() => { loadStats(); loadBatches(); }, [loadStats, loadBatches]);
  useEffect(() => {
    if (activeTab === "students") loadStudents(studentFilter);
    if (activeTab === "bookings") loadBookings();
    if (activeTab === "contacts") loadContacts();
  }, [activeTab, studentFilter, loadStudents, loadBookings]);

  // ── Handlers ──
  const handleCreateBatch = async () => {
    if (!newBatchName.trim()) return;
    try {
      await createBatch({ name: newBatchName, description: newBatchDesc });
      setBatchMsg({ text: "Batch created successfully!", type: "success" });
      setNewBatchName(""); setNewBatchDesc(""); loadBatches();
    } catch (e) {
      setBatchMsg({ text: "Error: " + (e.response?.data?.detail || "Failed"), type: "error" });
    }
    setTimeout(() => setBatchMsg({ text: "", type: "" }), 3000);
  };

  const handleDeleteBatch = async (id) => {
    if (!window.confirm("Delete this batch? Students will be unassigned.")) return;
    try { await deleteBatch(id); loadBatches(); } catch { }
  };

  const handleAssignBatch = async (studentId, batchId) => {
    try { await assignStudentBatch(studentId, batchId); loadStudents(studentFilter); } catch { }
  };

  const handleUpsertMeeting = async () => {
    if (!meetForm.meet_link.trim()) {
      setMeetMsg({ text: "Please enter a Google Meet link", type: "error" }); return;
    }
    try {
      await upsertMeeting(meetForm);
      setMeetMsg({ text: "✓ Meeting link saved and activated!", type: "success" });
      loadStats();
    } catch (e) {
      setMeetMsg({ text: "Error: " + (e.response?.data?.detail || "Failed"), type: "error" });
    }
    setTimeout(() => setMeetMsg({ text: "", type: "" }), 4000);
  };

  const handleSendEmail = async () => {
    if (!emailForm.meet_link) { setEmailMsg({ text: "Please enter a meet link first", type: "error" }); return; }
    setEmailSending(true); setEmailMsg({ text: "", type: "" });
    try {
      const r = await sendMeetEmail(emailForm);
      setEmailMsg({ text: `✓ Sent to ${r.data.sent || r.data.students_count} students`, type: "success" });
    } catch (e) {
      setEmailMsg({ text: "Error: " + (e.response?.data?.detail || "Failed to send"), type: "error" });
    }
    setEmailSending(false);
  };
  const addCustomTime = () => {
    const t = customTime.trim();
    if (!t) return;
    // Basic validation: must look like "H:MM AM/PM"
    if (!/^\d{1,2}:\d{2}\s?(AM|PM)$/i.test(t)) {
      setSlotsMsg({ text: "Use format like 9:00 AM or 7:30 PM", type: "error" });
      setTimeout(() => setSlotsMsg({ text: "", type: "" }), 2500);
      return;
    }
    const normalized = t.toUpperCase().replace(/\s+/g, " ");
    if (!selectedTimes.includes(normalized)) {
      setSelectedTimes(prev => [...prev, normalized]);
    }
    setCustomTime("");
  };

  const handleCreateSlots = async () => {
    if (!slotDate) {
      setSlotsMsg({ text: "Please pick a date", type: "error" }); return;
    }
    if (selectedTimes.length === 0) {
      setSlotsMsg({ text: "Please select at least one time slot", type: "error" }); return;
    }
    try {
      const r = await createSlots({ date: slotDate, times: selectedTimes });
      setSlotsMsg({ text: `✓ ${r.data.message || `${selectedTimes.length} slots created`}`, type: "success" });
      setSelectedTimes([]);
    } catch (e) {
      setSlotsMsg({ text: "Error: " + (e.response?.data?.detail || "Failed"), type: "error" });
    }
    setTimeout(() => setSlotsMsg({ text: "", type: "" }), 4000);
  };

  const handleStatusChange = async (id, status) => {
    try { await updateBookingStatus(id, status); loadBookings(); } catch { }
  };

  const filteredBookings = bookingFilter === "all"
    ? bookings
    : bookings.filter(b => b.status === bookingFilter);

  // Build half-hour slots grouped by period of day
  const generateTimeSlots = () => {
    const fmt = (h, m) => {
      const period = h >= 12 ? "PM" : "AM";
      const hr = h === 0 ? 12 : h > 12 ? h - 12 : h;
      return `${hr}:${String(m).padStart(2, "0")} ${period}`;
    };
    const build = (startH, endH) => {
      const out = [];
      for (let h = startH; h < endH; h++) {
        out.push(fmt(h, 0), fmt(h, 30));
      }
      return out;
    };
    return {
      Morning: build(9, 12),   // 9:00 AM – 11:30 AM
      Afternoon: build(12, 17),  // 12:00 PM – 4:30 PM
      Evening: build(17, 21),  // 5:00 PM – 8:30 PM
    };
  };

  const TIME_GROUPS = generateTimeSlots();
  // ═══════════════════════════════════════════════════════════════════════
  // TAB RENDERERS
  // ═══════════════════════════════════════════════════════════════════════

  const renderOverview = () => (
    <div className="tab-content">
      {/* Stats row */}
      <div className="stats-grid">
        <StatCard label="Registrations" value={stats?.total_students} icon={Icon.users} accent="#2563EB" />
        <StatCard label="Total Bookings" value={stats?.total_bookings} icon={Icon.calendar} accent="#8B5CF6" />
        <StatCard label="Confirmed" value={stats?.confirmed_bookings} icon={Icon.check} accent="#10B981" />
        <StatCard label="Batches" value={stats?.total_batches} icon={Icon.layers} accent="#F59E0B" />
      </div>

      <div className="overview-grid">
        {/* Active Meeting */}
        <div className="admin-card panel">
          <div className="panel-header">
            <span className="panel-title">Active Meeting</span>
            {stats?.has_active_meeting && (
              <span className="live-chip">● LIVE</span>
            )}
          </div>
          {stats?.has_active_meeting ? (
            <>
              <a href={stats.active_meet_link} target="_blank" rel="noopener noreferrer"
                className="meet-link-box">
                <span>{stats.active_meet_link}</span>
                {Icon.externalLink}
              </a>
              <button className="btn-ghost" style={{ marginTop: 10 }}
                onClick={() => { setActiveTab("sessions"); setSessionSubTab("email"); }}>
                {Icon.send} Send to students →
              </button>
            </>
          ) : (
            <div className="empty-state-sm">
              <p>No active meeting configured.</p>
              <button className="btn-primary" onClick={() => { setActiveTab("sessions"); setSessionSubTab("meeting"); }}>
                {Icon.link} Set Meeting Link
              </button>
            </div>
          )}
        </div>

        {/* Quick Actions */}
        <div className="admin-card panel">
          <div className="panel-header"><span className="panel-title">Quick Actions</span></div>
          <div className="quick-grid">
            <button className="quick-btn" onClick={() => { setActiveTab("sessions"); setSessionSubTab("meeting"); }}>
              <span className="quick-icon" style={{ background: "#EFF6FF", color: "#2563EB" }}>{Icon.video}</span>
              <span>Set Meet Link</span>
            </button>
            <button className="quick-btn" onClick={() => { setActiveTab("sessions"); setSessionSubTab("email"); }}>
              <span className="quick-icon" style={{ background: "#F5F3FF", color: "#7C3AED" }}>{Icon.mail}</span>
              <span>Send Email</span>
            </button>
            <button className="quick-btn" onClick={() => { setActiveTab("sessions"); setSessionSubTab("slots"); }}>
              <span className="quick-icon" style={{ background: "#ECFDF5", color: "#059669" }}>{Icon.clock}</span>
              <span>Add Slots</span>
            </button>
            <a href={exportStudentsCSV("all")} download className="quick-btn">
              <span className="quick-icon" style={{ background: "#FFF7ED", color: "#D97706" }}>{Icon.download}</span>
              <span>Export CSV</span>
            </a>
          </div>
        </div>

        {/* Recent bookings mini */}
        <div className="admin-card panel span-full">
          <div className="panel-header">
            <span className="panel-title">Recent Bookings</span>
            <button className="btn-ghost" onClick={() => setActiveTab("bookings")}>View all →</button>
          </div>
          <div className="mini-table-wrap">
            <table className="mini-table">
              <thead><tr><th>Name</th><th>Date</th><th>Time</th><th>Status</th></tr></thead>
              <tbody>
                {bookings.length === 0
                  ? <tr><td colSpan={4} className="empty-cell">No bookings yet</td></tr>
                  : bookings.slice(0, 5).map(b => (
                    <tr key={b.id}>
                      <td className="td-bold">{b.name}</td>
                      <td>{b.slot_date}</td>
                      <td>{b.slot_time}</td>
                      <td><span className={`badge ${STATUS_COLORS[b.status] || "badge-gray"}`}>{b.status}</span></td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

  // ── Students & Batches ──
  const renderStudents = () => (
    <div className="tab-content">
      <PillNav
        tabs={[
          { id: "list", label: "Student List", icon: Icon.users },
          { id: "batches", label: "Manage Batches", icon: Icon.layers },
        ]}
        active={studentSubTab}
        onChange={setStudentSubTab}
      />

      {studentSubTab === "list" && (
        <div className="section-body">
          {/* Toolbar */}
          <div className="toolbar">
            <div className="toolbar-left">
              <label className="filter-label">Batch</label>
              <select className="select-input" value={studentFilter}
                onChange={e => setStudentFilter(e.target.value)}>
                <option value="all">All Students</option>
                {batches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
              <span className="count-chip">{students.length} students</span>
            </div>
            <a href={exportStudentsCSV(studentFilter)} download className="btn-primary">
              {Icon.download} Export CSV
            </a>
          </div>

          {studentsLoading ? <div className="spinner" /> : (
            <div className="admin-card table-card">
              <div className="table-wrap">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>#</th><th>Name</th><th>Phone</th><th>Email</th>
                      <th>City</th><th>Course Interest</th><th>Batch</th><th>Registered</th>
                    </tr>
                  </thead>
                  <tbody>
                    {students.length === 0
                      ? <tr><td colSpan={8} className="empty-cell">No students found</td></tr>
                      : students.map((s, i) => (
                        <tr key={s.id}>
                          <td className="td-num">{i + 1}</td>
                          <td className="td-bold">{s.name}</td>
                          <td>{s.phone}</td>
                          <td>{s.email}</td>
                          <td>{s.city}</td>
                          <td>{s.course_interest}</td>
                          <td>
                            <select className="inline-select" value={s.batch_id || ""}
                              onChange={e => handleAssignBatch(s.id, e.target.value)}>
                              <option value="">— No Batch —</option>
                              {batches.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
                            </select>
                          </td>
                          <td className="td-muted">
                            {new Date(s.registered_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="table-footer">{students.length} record(s)</div>
            </div>
          )}
        </div>
      )}

      {studentSubTab === "batches" && (
        <div className="section-body">
          <div className="batches-layout">
            {/* Create form */}
            <div className="admin-card form-panel">
              <h3 className="form-panel-title">Create New Batch</h3>
              <div className="form-group">
                <label>Batch Name *</label>
                <input value={newBatchName} onChange={e => setNewBatchName(e.target.value)}
                  placeholder="e.g. Batch A — May 2026" />
              </div>
              <div className="form-group">
                <label>Description</label>
                <input value={newBatchDesc} onChange={e => setNewBatchDesc(e.target.value)}
                  placeholder="Optional description" />
              </div>
              <button className="btn-primary full-w" onClick={handleCreateBatch}>
                {Icon.plus} Create Batch
              </button>
              <Alert text={batchMsg.text} type={batchMsg.type} />
            </div>

            {/* Batches list */}
            <div className="batches-list">
              <p className="list-heading">Existing Batches ({batches.length})</p>
              {batches.length === 0
                ? <div className="admin-card empty-card">No batches created yet.</div>
                : batches.map(b => (
                  <div key={b.id} className="admin-card batch-row">
                    <div className="batch-row-info">
                      <div className="batch-row-name">{b.name}</div>
                      {b.description && <div className="batch-row-desc">{b.description}</div>}
                      <div className="batch-row-meta">
                        <span className="badge badge-blue">{b.student_count} students</span>
                        <span className="meta-date">Created {new Date(b.created_at).toLocaleDateString("en-IN")}</span>
                      </div>
                    </div>
                    <button className="icon-btn danger" onClick={() => handleDeleteBatch(b.id)}
                      title="Delete batch">
                      {Icon.trash}
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // ── Sessions (Meeting + Email + Slots) ──
  const renderSessions = () => (
    <div className="tab-content">
      <PillNav
        tabs={[
          { id: "meeting", label: "Meet Link", icon: Icon.link },
          { id: "email", label: "Send Email", icon: Icon.mail },
          { id: "slots", label: "Slots", icon: Icon.clock },
        ]}
        active={sessionSubTab}
        onChange={setSessionSubTab}
      />

      {sessionSubTab === "meeting" && (
        <div className="section-body">
          <div className="sessions-layout">
            <div className="admin-card form-panel">
              <h3 className="form-panel-title">Set Active Meeting Link</h3>
              <p className="form-hint">Setting a new link deactivates the previous one.</p>
              <div className="form-group">
                <label>Google Meet Link *</label>
                <input value={meetForm.meet_link}
                  onChange={e => setMeetForm(f => ({ ...f, meet_link: e.target.value }))}
                  placeholder="https://meet.google.com/xxx-xxxx-xxx" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Session Time</label>
                  <input value={meetForm.session_time}
                    onChange={e => setMeetForm(f => ({ ...f, session_time: e.target.value }))}
                    placeholder="7:00 PM IST" />
                </div>
                <div className="form-group">
                  <label>Session Title</label>
                  <input value={meetForm.title}
                    onChange={e => setMeetForm(f => ({ ...f, title: e.target.value }))}
                    placeholder="Daily Live Class" />
                </div>
              </div>
              <div className="form-group">
                <label>Date (optional)</label>
                <input type="date" value={meetForm.date}
                  onChange={e => setMeetForm(f => ({ ...f, date: e.target.value }))} />
              </div>
              <label className="toggle-label">
                <input type="checkbox" checked={meetForm.is_active}
                  onChange={e => setMeetForm(f => ({ ...f, is_active: e.target.checked }))} />
                Mark as active (visible to students)
              </label>
              <button className="btn-primary full-w" style={{ marginTop: 16 }} onClick={handleUpsertMeeting}>
                {Icon.link} Save Meeting Link
              </button>
              <Alert text={meetMsg.text} type={meetMsg.type} />
            </div>

            <div className="admin-card info-panel">
              <h3 className="form-panel-title">How It Works</h3>
              <ul className="info-steps">
                <li>Students register on the Student Meet page</li>
                <li>Set your Google Meet link here — it becomes visible instantly</li>
                <li>Use <strong>Send Email</strong> tab to notify all or specific batches</li>
                <li>Students can join directly from the Student Meet page</li>
                <li>Only one meeting link can be active at a time</li>
              </ul>

              {stats?.has_active_meeting && (
                <div className="active-meeting-box">
                  <div className="active-meeting-label">Currently Active</div>
                  <a href={stats.active_meet_link} target="_blank" rel="noopener noreferrer"
                    className="active-meeting-link">
                    {stats.active_meet_link}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {sessionSubTab === "email" && (
        <div className="section-body">
          <div className="sessions-layout">
            <div className="admin-card form-panel">
              <h3 className="form-panel-title">Send Meet Link to Students</h3>
              <div className="form-group">
                <label>Google Meet Link *</label>
                <input value={emailForm.meet_link}
                  onChange={e => setEmailForm(f => ({ ...f, meet_link: e.target.value }))}
                  placeholder="https://meet.google.com/xxx-xxxx-xxx" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Session Time</label>
                  <input value={emailForm.session_time}
                    onChange={e => setEmailForm(f => ({ ...f, session_time: e.target.value }))}
                    placeholder="7:00 PM IST" />
                </div>
                <div className="form-group">
                  <label>Session Title</label>
                  <input value={emailForm.session_title}
                    onChange={e => setEmailForm(f => ({ ...f, session_title: e.target.value }))}
                    placeholder="Daily Live Session" />
                </div>
              </div>
              <div className="form-group">
                <label>Send To</label>
                <select value={emailForm.batch_id}
                  onChange={e => setEmailForm(f => ({ ...f, batch_id: e.target.value }))}>
                  <option value="all">All Registered Students</option>
                  {batches.map(b => (
                    <option key={b.id} value={b.id}>{b.name} ({b.student_count} students)</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Custom Note (optional)</label>
                <input value={emailForm.custom_message}
                  onChange={e => setEmailForm(f => ({ ...f, custom_message: e.target.value }))}
                  placeholder="e.g. Today's session will cover MBBS in Russia..." />
              </div>
              <button className="btn-primary full-w" onClick={handleSendEmail} disabled={emailSending}>
                {Icon.send} {emailSending ? "Sending Emails…" : "Send Email to Selected Batch"}
              </button>
              <Alert text={emailMsg.text} type={emailMsg.type} />
            </div>

            {/* Email Preview */}
            <div className="admin-card email-preview-card">
              <h3 className="form-panel-title">Preview</h3>
              <div className="email-preview">
                <div className="ep-header">
                  <img src="/assets/TRANSPARENT_LOGO.png" alt="Logo" className="ep-logo" />
                  <div className="ep-tagline">Consultant & Immigration Services</div>
                </div>
                <div className="ep-body">
                  <p className="ep-greeting">Dear [Student Name],</p>
                  <p className="ep-text">We invite you to our upcoming <strong>Student Meet</strong> session.</p>
                  <div className="ep-session-box">
                    <div className="ep-field">
                      <span className="ep-field-label">SESSION</span>
                      <span className="ep-field-value">{emailForm.session_title || "Daily Live Session"}</span>
                    </div>
                    <div className="ep-field">
                      <span className="ep-field-label">TIME</span>
                      <span className="ep-field-value">{emailForm.session_time || "7:00 PM IST"}</span>
                    </div>
                  </div>
                  {emailForm.custom_message && (
                    <div className="ep-note">📝 {emailForm.custom_message}</div>
                  )}
                  <div className="ep-btn">Join Live Session →</div>
                  <p className="ep-link">{emailForm.meet_link || "https://meet.google.com/..."}</p>
                </div>
                <div className="ep-footer">ISTP Overseas Education Consultant & Immigration</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {sessionSubTab === "slots" && (
        <div className="section-body">
          <div className="admin-card form-panel" style={{ maxWidth: 720 }}>
            <h3 className="form-panel-title">Create Counselling Slots</h3>
            <p className="form-hint">Pick a date, then tap the time slots you want to open for booking.</p>

            <div className="form-group">
              <label>Date *</label>
              <input
                type="date"
                value={slotDate}
                min={new Date().toISOString().split("T")[0]}
                onChange={e => setSlotDate(e.target.value)}
              />
            </div>

            <div className="form-group">
              <div className="slot-picker-header">
                <label style={{ margin: 0 }}>Time Slots *</label>
                <span className="count-chip">{selectedTimes.length} selected</span>
              </div>

              {Object.entries(TIME_GROUPS).map(([period, times]) => (
                <div key={period} className="slot-picker-group">
                  <div className="slot-picker-period">{period}</div>
                  <div className="slot-picker-grid">
                    {times.map(t => {
                      const active = selectedTimes.includes(t);
                      return (
                        <button
                          key={t}
                          type="button"
                          className={`slot-chip${active ? " active" : ""}`}
                          onClick={() =>
                            setSelectedTimes(prev =>
                              active ? prev.filter(x => x !== t) : [...prev, t]
                            )
                          }
                        >
                          {t}
                        </button>
                      );
                    })}
                  </div>
                </div>
              ))}

              {/* Custom time escape hatch */}
              <div className="slot-custom-row">
                <input
                  value={customTime}
                  onChange={e => setCustomTime(e.target.value)}
                  placeholder="Custom time (e.g. 8:45 PM)"
                  onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addCustomTime(); } }}
                />
                <button type="button" className="btn-ghost" onClick={addCustomTime}>
                  {Icon.plus} Add
                </button>
              </div>

              {selectedTimes.length > 0 && (
                <button
                  type="button"
                  className="btn-ghost"
                  style={{ marginTop: 10 }}
                  onClick={() => setSelectedTimes([])}
                >
                  Clear all
                </button>
              )}
            </div>

            <button className="btn-primary full-w" onClick={handleCreateSlots}>
              {Icon.plus} Create {selectedTimes.length || ""} Slot{selectedTimes.length === 1 ? "" : "s"}
            </button>
            <Alert text={slotsMsg.text} type={slotsMsg.type} />
          </div>
        </div>
      )}
    </div>
  );

  // ── Bookings ──
  const renderBookings = () => (
    <div className="tab-content">
      <div className="toolbar">
        <div className="toolbar-left">
          <label className="filter-label">Filter</label>
          {["all", "confirmed", "completed", "cancelled"].map(s => (
            <button key={s}
              className={`filter-chip ${bookingFilter === s ? "active" : ""}`}
              onClick={() => setBookingFilter(s)}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
          <span className="count-chip">{filteredBookings.length}</span>
        </div>
      </div>

      {bookingsLoading ? <div className="spinner" /> : (
        <div className="admin-card table-card">
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr><th>#</th><th>Name</th><th>Phone</th><th>Email</th><th>Date</th><th>Time</th><th>Status</th><th>Meet Link</th><th>Action</th></tr>
              </thead>
              <tbody>
                {filteredBookings.length === 0
                  ? <tr><td colSpan={8} className="empty-cell">No bookings found</td></tr>
                  : filteredBookings.map((b, i) => (
                    <tr key={b.id}>
                      <td className="td-num">{i + 1}</td>
                      <td className="td-bold">{b.name}</td>
                      <td>{b.phone}</td>
                      <td>{b.email}</td>
                      <td>{b.slot_date}</td>
                      <td>{b.slot_time}</td>
                      <td><span className={`badge ${STATUS_COLORS[b.status] || "badge-gray"}`}>{b.status}</span></td>
                      <td><a href={b.meet_link} target="_blank" rel="noopener noreferrer">Join Meeting</a></td>
                      <td>
                        <select className="inline-select" value={b.status}
                          onChange={e => handleStatusChange(b.id, e.target.value)}>
                          <option value="confirmed">Confirmed</option>
                          <option value="completed">Completed</option>
                          <option value="cancelled">Cancelled</option>
                        </select>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="table-footer">{filteredBookings.length} booking(s)</div>
        </div>
      )}
    </div>
  );

  const renderContacts = () => (
    <div className="tab-content">
      <div className="admin-card table-card">
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Service</th>
                <th>Message</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {contacts.length === 0 ? (
                <tr>
                  <td colSpan={7} className="empty-cell">
                    No contact submissions
                  </td>
                </tr>
              ) : (
                contacts.map((c, i) => (
                  <tr key={c.id}>
                    <td>{i + 1}</td>
                    <td className="td-bold">{c.name}</td>
                    <td>{c.phone}</td>
                    <td>{c.email}</td>
                    <td>{c.service || "General"}</td>
                    <td style={{ maxWidth: "250px" }}>
                      {c.message || "—"}
                    </td>
                    <td>
                      {new Date(c.created_at).toLocaleDateString("en-IN")}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  // ═══════════════════════════════════════════════════════════════════════
  return (
    <div className="admin-page">
      {/* Mobile overlay */}
      <div className={`sidebar-overlay ${sidebarOpen ? "open" : ""}`}
        onClick={() => setSidebarOpen(false)} />

      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-brand">
          <img src="/assets/TRANSPARENT_LOGO.png" alt="ISTP Logo" className="sidebar-logo" />
          <span className="sidebar-sub">Admin Panel</span>
        </div>

        <nav className="sidebar-nav">
          {TABS.map(t => (
            <button key={t.id}
              className={`nav-btn ${activeTab === t.id ? "active" : ""}`}
              onClick={() => { setActiveTab(t.id); setSidebarOpen(false); }}>
              <span className="nav-icon">{t.icon}</span>
              <span className="nav-label">{t.label}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <a href="/" className="view-site-link">↗ View Site</a>
        </div>
      </aside>

      {/* Main */}
      <main className="admin-main">
        <header className="topbar">
          <div className="topbar-left">
            <button className="menu-btn" onClick={() => setSidebarOpen(true)}>{Icon.menu}</button>
            <div>
              <h1 className="topbar-title">
                {TABS.find(t => t.id === activeTab)?.icon}
                {TABS.find(t => t.id === activeTab)?.label}
              </h1>
              <p className="topbar-sub">ISTP Overseas Education — Admin</p>
            </div>
          </div>
        </header>

        <div className="admin-content">
          {activeTab === "overview" && renderOverview()}
          {activeTab === "students" && renderStudents()}
          {activeTab === "sessions" && renderSessions()}
          {activeTab === "bookings" && renderBookings()}
          {activeTab === "contacts" && renderContacts()}
          {activeTab === "messages" && <AdminMessages />}
        </div>
      </main>
    </div>
  );
}